// extracted by mini-css-extract-plugin
export default {"actionsContent":"UserItem_actionsContent__tqnk6","name":"UserItem_name__RDqqO","nameWrapper":"UserItem_nameWrapper__1zRzx","infoWrapper":"UserItem_infoWrapper__y1-Qg"};